module.exports = __webpack_public_path__ + "img/Mascot_habitation.6c5a3b80.png";